import { createApp, h } from "vue";
import App from "./App.vue";
import router from "./router";
import { store } from "./store";
import VueSweetalert2 from "vue-sweetalert2";
import VueSelect from "vue-next-select";

import { VueCsvImportPlugin } from "vue-csv-import";

import "./assets/css-vars.css";

import "sweetalert2/dist/sweetalert2.min.css";
import "vue-next-select/dist/index.min.css";

import "./assets/vue-next-select.css";

import "bootstrap/dist/js/bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";

// import "./assets/main.css";
// import "./assets/menu.css";

createApp({
  render: () => h(App),
})
  .use(VueSweetalert2)
  .use(VueCsvImportPlugin)
  .use(router)
  .use(store)
  .component("vue-select", VueSelect)
  .mount("#app");
